import config from '../../config/customer.api'
import { Request } from '../shared/base.requests'
export const contactModule = {
  namespaced: true,
  state: {
    contacts: []
  },
  mutations: {
    setContacts (state, payload) {
      state.contacts = payload
    }
  },
  actions: {
    getContacts ({commit}) {
      return new Promise((resolve, reject) => {
        Request.get(config.getContactsData).then(response => {
          if (!response.success) {
            return reject()
          }
          commit('setContacts', response.model)
          resolve()
        })
        .catch(error => {
          console.error('load contacts data error:', error)
          reject()
        })
      })
    }
  },
  getters: {
    contactData: state => {
      return [...state.contacts]
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/src/store/contact.js